import { BorderRightSharp } from "@mui/icons-material"
import { Container, MobileStepper } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledContainer = styled(Container)(({ theme }) => ({}))

export const StyledMobileStepper = styled(MobileStepper)(({ theme }) => ({
  maxWidth: "calc(100% - 11px)",
  flexGrow: 1,
  zIndex: 2,
  bottom: "0",
  position: "fixed",
  width: "100%",
  background: theme.palette.background.paper,
  boxShadow: "0px 0px 65px 0px rgb(0 0 0 / 6%)",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "calc(100% - 240px)"
  },
  [theme.breakpoints.down("xl")]: {
    "& .MuiLinearProgress-root": {
      display: "none"
    }
  },
  "& .MuiLinearProgress-root": {
    backgroundColor: theme.palette.grey[200],
    height: "6px",
    borderRadius: "100vh"
  },
  "& .MuiLinearProgress-bar": {
    backgroundColor: theme.palette.primary[700]
  }
}))
